import { Button } from "antd";
import cloneDeep from "lodash/cloneDeep";
import { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";
import { useHttp } from "../../../hooks/useHttp";
import { columnsConfigBySportForData, renameStandingPropertiesByConfig } from "../helpers";
import { useNotification } from "~hooks/useNotification";

const EditButton = ({ handleGetFormData }) => {
  const { sport, organizationId, standingId } = useParams();
  const { formatMessage } = useIntl();
  const { loading, error, request, cleanError } = useHttp();
  const [requestCount, setRequestCount] = useState(0);
  const notification = useNotification();

  useEffect(() => {
    if (error) {
      notification.error({
        message: "Unable to update standings",
        description: error,
        placement: "bottomRight",
      });
      cleanError();
    }
  }, [cleanError, error]);

  useEffect(() => {
    if (requestCount === 1) {
      notification.success({
        message: "Standings details updated",
        placement: "bottomRig",
      });
      setRequestCount(0);
    }
  }, [requestCount]);

  const updateStandings = async (data) => {
    const deepCloneCalculatedValue = cloneDeep(JSON.parse(data.calculated));
    const calculatedValueConvertedForData = Object.keys(deepCloneCalculatedValue).reduce((acc, key) => {
      acc[key] = renameStandingPropertiesByConfig(deepCloneCalculatedValue[key], columnsConfigBySportForData[sport]);
      return acc;
    }, {});
    data.calculated = JSON.stringify(calculatedValueConvertedForData);

    try {
      const res = await request({
        url: `/v1/${sport}/o/${organizationId}/standings/${standingId}`,
        method: "PUT",
        body: data,
      });
      setRequestCount((prev) => prev + 1);
    } catch (e) {
      console.error(e);
    }
  };

  const handleUpdate = async () => {
    const data = await handleGetFormData();
    updateStandings(data);
  };

  return (
    <div style={{ textAlign: "center" }}>
      <Button loading={loading} type={"primary"} size={"large"} onClick={handleUpdate}>
        {formatMessage({
          id: "standings.row.edit.submit",
          defaultMessage: "Submit changes",
        })}
      </Button>
    </div>
  );
};

export default EditButton;
